function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { Button, Input, message, Radio, Spin } from "@pionex-web-kit/components";
import Decimal from "decimal.js";
import { Component } from "react";
import { NumberCommonUtils, SafeDecimal } from "trade_utils_lib";
import { $st } from "../../utils/i18n";
import NumberUtils from "../../utils/NumberUtils";
import { SpaceBetweenText } from "../TradeCommonUI";
import "./TWAPTrading.less";
import React from "react";
import { TradingGlobalContext } from "../../context/TradingGlobalContext";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var DEFAULT_STATE = {
  period: 10,
  totalTimes: undefined,
  investmentPerTime: undefined,
  totalInvestment: 0,
  loading: false,
  perInvestError: false,
  totalTimesError: false,
  enableTrading: false //默认按钮置灰
};

var MIN_TOTAL_TIMES = 1; // 最小交易次数

export var TWAPTradingCheckTOCreateOrder = function TWAPTradingCheckTOCreateOrder(symbol, side, totalTimes, totalInvest, balance, minCost) {
  var investmentPerTimeNum = 0;
  if (side === "buy") {
    investmentPerTimeNum = NumberUtils.toPriceNumBySymbol(new SafeDecimal(totalInvest).div(new SafeDecimal(totalTimes)).toString(), symbol);
  } else {
    investmentPerTimeNum = NumberUtils.toAmountNumBySymbol(new SafeDecimal(totalInvest).div(new SafeDecimal(totalTimes)).toString(), symbol);
  }
  var enableTrading = false;
  var disableMsg = "";
  if (balance) {
    if (totalInvest <= 0) {
      enableTrading = false;
      // disableMsg = $st("trading_twap_total_investment_null");
    } else if (totalInvest > balance) {
      disableMsg = $st("trading_twap_balance_not_enough");
    } else if (minCost && investmentPerTimeNum < minCost) {
      enableTrading = false;
      if (side === "buy") {
        disableMsg = $st("trading_twap_buy_quantity_low", {
          quote: symbol.quote,
          min: NumberUtils.toPriceNumBySymbol(minCost, symbol, Decimal.ROUND_CEIL),
          total: NumberUtils.toPriceNumBySymbol(minCost * totalTimes, symbol, Decimal.ROUND_CEIL)
        });
      } else {
        disableMsg = $st("trading_twap_sell_quantity_low", {
          min: NumberUtils.toAmountNumBySymbol(minCost, symbol, Decimal.ROUND_CEIL),
          quote: symbol.quote
        });
      }
    } else {
      enableTrading = true;
    }
  } else {
    disableMsg = $st("trade_balance_no_result");
  }
  return {
    result: enableTrading,
    msg: disableMsg
  };
};

/**
 * 输入的每次投资额是否合法
 */
function checkPerInvestRes(minVolume, perInvest, precision) {
  var perValue = NumberCommonUtils.formatterDecimal(new SafeDecimal(perInvest), precision).toNumber();
  var min = NumberCommonUtils.formatterDecimal(minVolume, precision, Decimal.ROUND_CEIL).toNumber();
  if (perValue < min) {
    return false;
  }
  return true;
}

/**
 * 输入的次数是否合法
 */
function checkTotalTimesRes(totalTimes) {
  return totalTimes >= MIN_TOTAL_TIMES;
}
var TWAPTradingContent = /*#__PURE__*/function (_Component) {
  _inherits(TWAPTradingContent, _Component);
  var _super = _createSuper(TWAPTradingContent);
  function TWAPTradingContent() {
    var _this;
    _classCallCheck(this, TWAPTradingContent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", DEFAULT_STATE);
    _defineProperty(_assertThisInitialized(_this), "componentWillReceiveProps", function (props) {
      if (props.tradeSelectedInfo !== _this.props.tradeSelectedInfo) {
        _this.resetView();
      }
      if (props.minVolume !== _this.props.minVolume && _this.props.orderInfo !== undefined && _this.props.orderInfo.exchangeTWAPOrder.side === _this.props.side) {
        var twapOrder = _this.props.orderInfo.exchangeTWAPOrder;
        _this.changeByOrder(twapOrder);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "changeByOrder", function (twapOrder) {
      var perInvest = NumberCommonUtils.formatterDecimal(new SafeDecimal(twapOrder.totalTimes).div(new SafeDecimal(twapOrder.totalTimes)), _this.getPrecision()).toNumber();
      _this.paramsDidChanged(twapOrder.interval, perInvest, twapOrder.totalTimes, _this.props.minVolume || 0);
    });
    _defineProperty(_assertThisInitialized(_this), "onRadioChanged", function (e) {
      var period = e.target.value;
      var _this$state = _this.state,
        totalTimes = _this$state.totalTimes,
        investmentPerTime = _this$state.investmentPerTime;
      _this.paramsDidChanged(period, investmentPerTime, totalTimes, _this.props.minVolume || 0);
    });
    _defineProperty(_assertThisInitialized(_this), "handlePerInvestChange", function (value) {
      var _this$state2 = _this.state,
        period = _this$state2.period,
        totalTimes = _this$state2.totalTimes;
      _this.paramsDidChanged(period, !value && value !== 0 ? undefined : value, totalTimes, _this.props.minVolume || 0);
    });
    _defineProperty(_assertThisInitialized(_this), "handleTotalTimesChange", function (value) {
      var _this$state3 = _this.state,
        period = _this$state3.period,
        investmentPerTime = _this$state3.investmentPerTime;
      _this.paramsDidChanged(period, investmentPerTime, !value && value !== 0 ? undefined : Number(value), _this.props.minVolume || 0);
    });
    _defineProperty(_assertThisInitialized(_this), "paramsDidChanged", function (period, investmentPerTime, totalTimes, minCost) {
      var emptyPerTime = false; // 空内容perTime
      var emptyTotalTimes = false; // 空内容totalTimes
      if (!investmentPerTime && investmentPerTime !== 0) {
        emptyPerTime = true;
      }
      if (!totalTimes && totalTimes !== 0) {
        emptyTotalTimes = true;
      }

      //计算用数字，state用原值
      var totalInvest = NumberCommonUtils.formatterDecimal(new SafeDecimal(totalTimes || 0).mul(new SafeDecimal(investmentPerTime || 0)), _this.getPrecision()).toNumber();
      var perInvestError = !checkPerInvestRes(minCost, investmentPerTime || 0, _this.getPrecision()) || !!_this.props.balance && totalInvest >= _this.props.balance.available;
      var totalTimesError = !checkTotalTimesRes(totalTimes || 0);
      _this.setState({
        period: period,
        totalTimes: totalTimes,
        totalInvestment: totalInvest,
        investmentPerTime: investmentPerTime,
        perInvestError: !emptyPerTime && perInvestError,
        totalTimesError: !emptyTotalTimes && totalTimesError,
        enableTrading: !perInvestError && !totalTimesError
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onStartClick", function () {
      var _this$props = _this.props,
        side = _this$props.side,
        balance = _this$props.balance,
        tradeSelectedInfo = _this$props.tradeSelectedInfo,
        _this$props$minVolume = _this$props.minVolume,
        minVolume = _this$props$minVolume === void 0 ? 0 : _this$props$minVolume;
      var _this$state4 = _this.state,
        period = _this$state4.period,
        totalInvestment = _this$state4.totalInvestment,
        _this$state4$totalTim = _this$state4.totalTimes,
        totalTimes = _this$state4$totalTim === void 0 ? 0 : _this$state4$totalTim;
      var checkRes = TWAPTradingCheckTOCreateOrder(tradeSelectedInfo.symbol, side, totalTimes, totalInvestment, balance ? balance.available : 0, minVolume);
      if (!checkRes.result) {
        message.error(checkRes.msg);
        return;
      }
      _this.props.onCreateOrder({
        period: period,
        totalInvestment: totalInvestment,
        totalTimes: totalTimes
      });
    });
    _defineProperty(_assertThisInitialized(_this), "getPrecision", function () {
      var _this$props2 = _this.props,
        side = _this$props2.side,
        tradeSelectedInfo = _this$props2.tradeSelectedInfo;
      var symbol = tradeSelectedInfo.symbol;
      var isBuy = side === "buy";
      return (isBuy ? symbol.precision : symbol.amount) || 4;
    });
    return _this;
  }
  _createClass(TWAPTradingContent, [{
    key: "reCreateOrder",
    value: function reCreateOrder() {
      var _this2 = this;
      var _ref = this.context,
        reOrderData = _ref.reOrderData;
      if (!reOrderData || !reOrderData.exchangeTWAPOrder) return;
      var _reOrderData$exchange = reOrderData.exchangeTWAPOrder,
        interval = _reOrderData$exchange.interval,
        totalVolume = _reOrderData$exchange.totalVolume,
        totalTimes = _reOrderData$exchange.totalTimes;
      this.onRadioChanged({
        target: {
          value: interval
        }
      });
      this.handleTotalTimesChange(totalTimes);
      setTimeout(function () {
        _this2.handlePerInvestChange(new SafeDecimal(totalVolume).div(totalTimes).toNumber());
      }, 1000);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.orderInfo && this.props.orderInfo.exchangeTWAPOrder && this.props.orderInfo.exchangeTWAPOrder.side === this.props.side) {
        var twapOrder = this.props.orderInfo.exchangeTWAPOrder;
        this.changeByOrder(twapOrder);
      }
      this.reCreateOrder();
    }
  }, {
    key: "resetView",
    value: function resetView() {
      this.setState(DEFAULT_STATE);
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var _this3 = this;
      var _this$props3 = this.props,
        tradeSelectedInfo = _this$props3.tradeSelectedInfo,
        balance = _this$props3.balance,
        _this$props3$minVolum = _this$props3.minVolume,
        minVolume = _this$props3$minVolum === void 0 ? 0 : _this$props3$minVolum,
        side = _this$props3.side;
      var _this$state5 = this.state,
        period = _this$state5.period,
        totalInvestment = _this$state5.totalInvestment,
        investmentPerTime = _this$state5.investmentPerTime,
        totalTimes = _this$state5.totalTimes,
        perInvestError = _this$state5.perInvestError,
        totalTimesError = _this$state5.totalTimesError,
        enableTrading = _this$state5.enableTrading;
      var symbol = tradeSelectedInfo.symbol;
      var isBuy = side === "buy";
      var title = "".concat(isBuy ? $st("twap_buy_rate_title") : $st("twap_sell_rate_title"), " ").concat(symbol.baseDisplay);
      var unitDisplay = isBuy ? symbol.quote : symbol.baseDisplay;
      var availableBalance = "-";
      if (balance) {
        availableBalance = "".concat(NumberUtils.toAmountBySymbol(balance.available, symbol), " ").concat(unitDisplay);
      }
      var minVolumeStr = "";
      if (isBuy) {
        minVolumeStr = NumberUtils.toPriceBySymbol(minVolume, symbol, Decimal.ROUND_CEIL);
      } else {
        minVolumeStr = NumberUtils.toAmountBySymbol(minVolume, symbol, Decimal.ROUND_CEIL);
      }
      var maxVolumeStr = "";
      if (balance && investmentPerTime) {
        var maxVolumePerTime = new SafeDecimal(balance.available).div(new SafeDecimal(totalTimes)).toNumber();
        if (maxVolumePerTime < investmentPerTime) maxVolumeStr = NumberCommonUtils.toFix(maxVolumePerTime, symbol.precision);
      }
      var precision = this.getPrecision();
      var totalPerInvestPlaceHolder = "".concat(isBuy ? $st("trading_twap_buy_cost_per_time_label") : $st("trading_twap_sell_quantity_per_time_label"), "(").concat(maxVolumeStr ? "\u2264".concat(maxVolumeStr) : "\u2265".concat(minVolumeStr), " ").concat(unitDisplay, ")");
      var totalTimesPlaceHolder = "".concat($st("grid_transaction"), "(\u2265").concat(MIN_TOTAL_TIMES, ")");
      var buyTotalLabel = $st("twap_buy_all_invest");
      var sellTotalLabel = $st("twap_sell_all_invest");
      var expendTotalLabel = isBuy ? buyTotalLabel : sellTotalLabel;
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("div", {
          className: "textSmAccentSub",
          children: title
        }), /*#__PURE__*/_jsxs(Radio.Group, {
          className: "radioPeriod",
          size: "small",
          defaultValue: period,
          value: period,
          bgStyle: "separate-border",
          onChange: this.onRadioChanged,
          children: [/*#__PURE__*/_jsx(Radio.Button, {
            value: 10,
            children: "10 ".concat($st("strateg_Sec"))
          }), /*#__PURE__*/_jsx(Radio.Button, {
            value: 30,
            children: "30 ".concat($st("strateg_Sec"))
          }), /*#__PURE__*/_jsx(Radio.Button, {
            value: 60,
            children: "1 ".concat($st("strateg_Min"))
          }), /*#__PURE__*/_jsx(Radio.Button, {
            value: 300,
            children: "5 ".concat($st("strateg_Min"))
          })]
        }), /*#__PURE__*/_jsx(Input, {
          className: "mt-16px",
          type: "number",
          label: totalPerInvestPlaceHolder,
          value: investmentPerTime,
          onChange: function onChange(e) {
            _this3.handlePerInvestChange(e.target.value);
          },
          precision: precision,
          status: perInvestError ? "error" : undefined
        }), /*#__PURE__*/_jsx(Input, {
          className: "mt-16px",
          type: "number",
          label: totalTimesPlaceHolder,
          value: totalTimes,
          onChange: function onChange(e) {
            _this3.handleTotalTimesChange(e.target.value);
          },
          precision: 0,
          status: totalTimesError ? "error" : undefined
        }), /*#__PURE__*/_jsx(SpaceBetweenText, {
          className: "mt-16px",
          leftText: $st("trade_available"),
          rightText: availableBalance
        }), /*#__PURE__*/_jsx(SpaceBetweenText, {
          leftText: expendTotalLabel,
          rightText: "".concat(totalInvestment, " ").concat(unitDisplay)
        }), /*#__PURE__*/_jsx(Button, {
          type: "primary",
          className: "orderCreateButton",
          onClick: this.onStartClick,
          disabled: !enableTrading,
          children: $st("aip_button_start")
        })]
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.loading) {
        return /*#__PURE__*/_jsx(Spin, {
          wrapperClassName: "h-auto",
          children: this.renderContent()
        });
      } else {
        return this.renderContent();
      }
    }
  }]);
  return TWAPTradingContent;
}(Component);
_defineProperty(TWAPTradingContent, "contextType", TradingGlobalContext);
export default TWAPTradingContent;